// import { onUnmounted } from 'vue'

const customEventDirective = {
  name: 'customEvent',
  mounted(el, binding) {
    console.log({
      el
    });
    console.log({
      binding
    });

    // const onClickOutside = (event: any) => {
    //   if (!el.contains(event.target) && el !== event.target) {
    //     console.log('click============>', binding)
    //   }
    // }

    // document.addEventListener('click', onClickOutside)

    // 在组件卸载时移除事件监听器
    // onUnmounted(() => {
    //   document.removeEventListener('click', onClickOutside)
    // })
    // const app = createApp(Loading)
    // const instance = app.mount(document.createElement('div'))
    // el.instance = instance
    // const title = binding.arg
    // if (typeof title !== 'undefined') {
    //   ;(instance as any).setTitle(title)
    // }
    // if (typeof binding.value === 'object' && binding.value !== null && binding.value.text) {
    //   ;(instance as any).setTitle(binding.value.text)
    // }
    // if (binding.value) {
    //   if (typeof binding.value === 'boolean') append(el)
    //   if (typeof binding.value === 'object' && binding.value !== null) {
    //     if (binding.value.value) append(el)
    //   }
    // }
  },
  updated(el, binding) {
    console.log({
      el
    });
    console.log({
      binding
    });
    // const title = binding.arg

    // if (typeof title !== 'undefined') {
    //   el.instance.setTitle(title)
    // }

    if (binding.value !== binding.oldValue) {
      // bool的情况
      // if (typeof binding.value === 'boolean') {
      //   // eslint-disable-next-line no-unused-expressions
      //   binding.value ? append(el) : remove(el)
      // }
      // object的情况
      // if (typeof binding.value === 'object' && binding.value !== null) {
      //   // eslint-disable-next-line no-unused-expressions
      //   binding.value.value ? append(el) : remove(el)
      // }
    }
  }
  // unmounted(el: HTMLElement & { instance: any }) {}
};
export default customEventDirective;